export default {
  'Japan': 'jpy',
  'United States': 'usd'
}
